module.exports = __webpack_public_path__ + "img/fire.ce56b01d.gif";